export default __webpack_public_path__ + "static/media/ListPlus.101fb82f.svg";